import { GetMembershipDetails } from '../contracts';
import { IneligibityReasonCode, MSSMobileAuthStatus, MSSProductStatus, MSSSpinOffStatus } from '@lib/types';
import {
  GenderType,
  MSSMemberStatus,
  MembershipLevel,
  MembershipProductType,
  PhoneType,
  RoleType,
} from '@ace-clublabs/common-membership-api-types';
import { IMemberDetails } from '../../state/model';

export const GetMembershipDetailsStub: GetMembershipDetails = async () => {
  return await Promise.resolve(getMembershipDetailsApiStub);
};

export const getMembershipDetailsApiStub: IMemberDetails = {
  sessionId: 'some-session-id',
  clubCode: '004',
  loggedInCustomerId: '642446020031242',
  selectedCustomerId: undefined,
  clubRegion: '00',
  joinYear: '2015',
  longevity: '5',
  renewexpiredate: '05/05/2026',
  members: [
    {
      roleCode: '00',
      customerId: '642446020031242',
      membershipCardNumber: '6200041234567801',
      firstName: 'JANET',
      middleName: 'SMITH',
      lastName: 'MORALES',
      nameSuffix: 'Sr',
      roleType: RoleType.PRIMARY,
      status: MSSMemberStatus.EXISTING,
      plasticReplacementCard: { eligible: true, ineligibityReasonCode: null },
      phoneNumbers: [
        {
          type: PhoneType.MOBILE,
          areaCode: '555',
          prefix: '555',
          suffix: '5555',
          mobileAuthStatus: MSSMobileAuthStatus.CONSENTED,
        },
        {
          type: PhoneType.HOME,
          areaCode: '666',
          prefix: '666',
          suffix: '6666',
          mobileAuthStatus: MSSMobileAuthStatus.NOT_RESPONDED,
          isMobilePhone: true,
        },
      ],
      emailAddress: 'jmorales@email.com',
      rules: {
        viewMembership: true,
        changeMembership: true,
        makePayment: true,
        updateEmail: true,
        updatePhone: true,
        nameChange: {
          firstName: true,
          middleName: true,
          lastName: true,
          suffix: true,
        },
      },
      residenceAddress: {
        addressLine1: '123 MAIN ST',
        addressLine2: 'APARTMENT 1',
        city: 'LOS ANGELES',
        state: 'CA',
        zip: '90007',
      },
      mailingAddress: {
        addressLine1: '456 MAIN ST',
        city: 'LOS ANGELES',
        state: 'CA',
        zip: '90007',
      },
      joinYear: '2015',
    },
    {
      roleCode: '06',
      customerId: '11111111',
      membershipCardNumber: '6200041234567802',
      firstName: 'JAMES',
      lastName: 'MORALES',
      roleType: RoleType.ADULT_ASSOCIATE,
      status: MSSMemberStatus.EXISTING,
      emailAddress: 'associate@aaa.com',
      plasticReplacementCard: { eligible: true, ineligibityReasonCode: null },
      rules: {
        viewMembership: true,
        changeMembership: true,
        makePayment: true,
        updateEmail: true,
        updatePhone: true,
        nameChange: {
          firstName: true,
          middleName: true,
          lastName: true,
          suffix: true,
        },
      },
      phoneNumbers: [],
      residenceAddress: {
        addressLine1: '123 MAIN ST',
        addressLine2: 'APARTMENT 1',
        city: 'LOS ANGELES',
        state: 'CA',
        zip: '90007',
      },
      mailingAddress: {
        addressLine1: '456 MAIN ST',
        city: 'LOS ANGELES',
        state: 'CA',
        zip: '90007',
      },
    },
    {
      roleCode: '01',
      customerId: '22222222',
      membershipCardNumber: '6200041234567803',
      firstName: 'JOE',
      lastName: 'MORALES',
      middleName: 'AUSTIN',
      nameSuffix: 'Jr.', //confirm what format suffix is returned from api
      roleType: RoleType.DEPENDENT,
      status: MSSMemberStatus.EXISTING,
      plasticReplacementCard: { eligible: true, ineligibityReasonCode: null },
      rules: {
        viewMembership: false,
        changeMembership: false,
        makePayment: false,
        updateEmail: true,
        updatePhone: true,
        nameChange: {
          firstName: true,
          middleName: true,
          lastName: true,
          suffix: true,
        },
      },
      residenceAddress: {
        addressLine1: '123 MAIN ST',
        addressLine2: 'APARTMENT 1',
        city: 'LOS ANGELES',
        state: 'CA',
        zip: '90007',
      },
      mailingAddress: {
        addressLine1: '456 MAIN ST',
        city: 'LOS ANGELES',
        state: 'CA',
        zip: '90007',
      },
      spinOffStatus: MSSSpinOffStatus.SPIN_OFF,
    },
  ],
  benefitLevels: {
    existingLevel: MembershipLevel.PLUS_RV,
    pendingLevel: MembershipLevel.PREMIER,
    effectiveDate: '6/24/2024',
  },
  products: [
    {
      type: MembershipProductType.RV,
      status: MSSProductStatus.EXISTING,
      effectiveDate: '06-30-2024',
    },
  ],
  inArrears: 'N',
  inRenewal: 'N',
};
